import { RevxMoney } from 'components/RevxMoney';

interface Props {
  value: number;
  decoration?: boolean;
  hidden?: boolean;
}

export const ComparisonMoney = (props: Props) => {
  const { value, decoration, hidden } = props;
  return (
    <span
      hidden={hidden}
      style={{
        textDecoration: decoration ? 'line-through' : 'none',
      }}
    >
      <RevxMoney value={value} />
    </span>
  );
};
